export default "__VITE_ASSET__BexINJb0__"